export default __webpack_public_path__ + "static/media/logo.d0f37e6f.png";